import * as yup from 'yup';

import { isValidBigIntValue } from '@/shared/utils/helpers';

const BIGINT_CONST = '1000000000000000000000000000000'; // 1e30

const personalisedPoolSchema = yup.object({
    type: yup.string().required('Type is required.'),
    token: yup.string().required('Token is required.'),
    position: yup
        .string()
        .required(`Please enter the asset size you'd like to lend or borrow.`)
        .test(
            'is-valid-numeric-range',
            `Position must be a numeric value between 0.01 and 1e30.`,
            (value) => {
                if (!value) return true;
                return isValidBigIntValue(value, BIGINT_CONST);
            },
        ),
    apy: yup
        .string()
        .required('Please specify the desired APY.')
        .test(
            'is-valid-numeric-range',
            'APY must be a numeric value between 0.01 and 9999.99.',
            (value) => {
                if (!value) return true;
                const numericValue = parseFloat(value);
                return !isNaN(numericValue) && numericValue >= 0.01 && numericValue <= 9999.99;
            },
        ),
    details: yup
        .string()
        .max(1000, 'Details should not exceed 1000 characters.')
        .required('This field is required. Please provide additional details to proceed.'),
});

export interface PersonalisedPoolData {
    type: string;
    token: string;
    position: string;
    apy: string;
    details: string;
}

export default personalisedPoolSchema;
